export default __webpack_public_path__ + "static/media/C902.f1993241.webp";